<template>
<v-container class="pa-10">
    <v-container>
      <div class="text-h5">Área administrativa</div>
      <v-divider />
    </v-container> 
    <v-container>
      <v-row>
        <v-col cols="auto">
          <v-select
            :items="items"
            v-model="itemSelecionado"
            label="Tipo de cadastro"
            dense
            outlined
            hide-details
          ></v-select>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <usuario
          v-if="itemSelecionado === 1"
          :itemSelecionado="itemSelecionado"
        ></usuario>
        <plano
          v-if="itemSelecionado === 2"
          :itemSelecionado="itemSelecionado"
        ></plano>
        <tema
          v-if="itemSelecionado === 3"
          :itemSelecionado="itemSelecionado"
        ></tema>
        <questao
          v-if="itemSelecionado === 4"
          :itemSelecionado="itemSelecionado"
        ></questao>
        <prova
          v-if="itemSelecionado === 5"
          :itemSelecionado="itemSelecionado"
        ></prova>
        <institucional
          v-if="itemSelecionado === 6"
          :itemSelecionado="itemSelecionado"
        ></institucional>
        <especialidade
          v-if="itemSelecionado === 7"
          :itemSelecionado="itemSelecionado"
        ></especialidade>
        <parametro
          v-if="itemSelecionado === 8"
          :itemSelecionado="itemSelecionado"
        ></parametro>
        <perfil v-if="itemSelecionado === 9" :itemSelecionado="itemSelecionado" />
        <produto
          v-if="itemSelecionado === 10"
          :itemSelecionado="itemSelecionado"
        />
      </v-row>
    </v-container>
</v-container>
</template>
<script>
  import usuario from '../administrativo/Usuario.vue';
  import plano from '../administrativo/Plano';
  import tema from '../administrativo/Tema.vue';
  import questao from '../administrativo/Questoes.vue';
  import prova from '../administrativo/Prova.vue';
  import institucional from '../administrativo/Institucional.vue';
  import especialidade from '../administrativo/Especialidade.vue';
  import parametro from '../administrativo/Parametro.vue';
  import perfil from '../administrativo/Perfil.vue';
  import produto from '../administrativo/Produto.vue';

  export default {
    components: {
      usuario,
      plano,
      tema,
      questao,
      prova,
      institucional,
      especialidade,
      parametro,
      perfil,
      produto,
    },
    data: () => ({
      itemSelecionado: '',
      dense: false,
      items: [
        { value: 1, text: 'Usuário' },
        { value: 2, text: 'Plano de acesso' },
        { value: 3, text: 'Temas' },
        { value: 4, text: 'Questões' },
        { value: 5, text: 'Provas' },
        { value: 6, text: 'Institucionais' },
        { value: 7, text: 'Especialidades' },
        { value: 8, text: 'Parâmetros' },
        { value: 9, text: 'Perfis' },
        { value: 10, text: 'Produto' },
      ],
    }),
  };
</script>

<style lang="scss">
  .v-data-footer {
    flex-wrap: nowrap !important;
    &__select {
      .v-select {
        margin: 13px 0 12px 10px !important;
      }
    }
    &__pagination {
      margin: 0 !important;
    }
  }
</style>
